import {
  type ContactTypeFlags,
  findFirstContactOfType
} from '~/domains/contacts/contactTypes'

export const findDefaultInvoiceContact = <
  T extends { id: number } & Partial<ContactTypeFlags>
>(
  selectableContacts: T[],
  orderContactId?: number
): T | undefined =>
  findFirstContactOfType(selectableContacts, 'typeBilling') ??
  selectableContacts.find((contact) => contact.id === orderContactId)
